module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product-map', {
    attrs: {
      "data": _vm.data,
      "num": 4,
      "text": "新增"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71592614", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71592614"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/panel/style.vue
// module id = 2819
// module chunks = 0